// extracted by mini-css-extract-plugin
export default {"footbar":"Footer_footbar__WM05a","glyphs":"Footer_glyphs__XFisC"};